webpackJsonp([223049868600526],{

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n   background: center/cover no-repeat url(", ");\n   height: 100vmin;\n   min-height: 80rem;\n   padding: ", "rem;\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   position: relative;\n   ", " ", "\n\t &:after {\n      content: \"\";\n      display: block;\n      background: radial-gradient(rgba(255, 255, 255, 0) 40%, rgba(63, 62, 62, 0.4) 60%);\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      z-index: 2;\n   }\n"], ["\n   background: center/cover no-repeat url(", ");\n   height: 100vmin;\n   min-height: 80rem;\n   padding: ", "rem;\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   position: relative;\n   ", " ", "\n\t &:after {\n      content: \"\";\n      display: block;\n      background: radial-gradient(rgba(255, 255, 255, 0) 40%, rgba(63, 62, 62, 0.4) 60%);\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      z-index: 2;\n   }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n\t padding: ", "rem;\n\t "], ["\n\t padding: ", "rem;\n\t "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n\t padding: ", "rem;\n\t min-height: 70rem;\n\n\t "], ["\n\t padding: ", "rem;\n\t min-height: 70rem;\n\n\t "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n   text-align: center;\n   padding: ", "rem ", "rem;\n   max-width: 90rem;\n   background: rgba(255, 255, 255, 0.85);\n   position: relative;\n   z-index: 4;\n   ", " ", "\n\n   h2 {\n      padding-bottom: 5rem;\n      ", " ", ";\n   }\n\n   h4 {\n      margin: 0 auto;\n      max-width: 60rem;\n   }\n\n   form {\n      margin: 0 auto;\n      text-align: left;\n\n      button {\n         color: ", ";\n         font-size: 1.5rem;\n         margin-top: 4rem;\n      }\n   }\n\n   .close-button {\n      position: absolute;\n      display: block;\n      top: 1rem;\n      right: 1rem;\n      height: 25px;\n      width: 25px;\n      cursor: pointer;\n\n      &:before {\n         content: \"\";\n         position: absolute;\n         display: block;\n         height: 1px;\n         width: 25px;\n         top: 12px;\n         right: 0;\n         background-color: rgb(25, 25, 25);\n         transform: rotate(45deg);\n      }\n\n      &:after {\n         content: \"\";\n         position: absolute;\n         display: block;\n         height: 1px;\n         width: 25px\n         top: 12px;\n         right: 0;\n         background-color: rgb(25, 25, 25);\n         transform: rotate(-45deg);\n         cursor: pointer;\n      }\n   }\n\n"], ["\n   text-align: center;\n   padding: ", "rem ", "rem;\n   max-width: 90rem;\n   background: rgba(255, 255, 255, 0.85);\n   position: relative;\n   z-index: 4;\n   ", " ", "\n\n   h2 {\n      padding-bottom: 5rem;\n      ", " ", ";\n   }\n\n   h4 {\n      margin: 0 auto;\n      max-width: 60rem;\n   }\n\n   form {\n      margin: 0 auto;\n      text-align: left;\n\n      button {\n         color: ", ";\n         font-size: 1.5rem;\n         margin-top: 4rem;\n      }\n   }\n\n   .close-button {\n      position: absolute;\n      display: block;\n      top: 1rem;\n      right: 1rem;\n      height: 25px;\n      width: 25px;\n      cursor: pointer;\n\n      &:before {\n         content: \"\";\n         position: absolute;\n         display: block;\n         height: 1px;\n         width: 25px;\n         top: 12px;\n         right: 0;\n         background-color: rgb(25, 25, 25);\n         transform: rotate(45deg);\n      }\n\n      &:after {\n         content: \"\";\n         position: absolute;\n         display: block;\n         height: 1px;\n         width: 25px\n         top: 12px;\n         right: 0;\n         background-color: rgb(25, 25, 25);\n         transform: rotate(-45deg);\n         cursor: pointer;\n      }\n   }\n\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose([";\n      margin-top: 6rem;\n\t\t\tpadding: ", "rem;\n   "], [";\n      margin-top: 6rem;\n\t\t\tpadding: ", "rem;\n   "]),
	    _templateObject6 = _taggedTemplateLiteralLoose([";\n      margin-top: 4rem;\n\t\t\tpadding: ", "rem ", "rem;\n   "], [";\n      margin-top: 4rem;\n\t\t\tpadding: ", "rem ", "rem;\n   "]),
	    _templateObject7 = _taggedTemplateLiteralLoose([";\n\t\t\tpadding-bottom: ", "rem;\n   "], [";\n\t\t\tpadding-bottom: ", "rem;\n   "]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _functions = __webpack_require__(6);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _enqForm = __webpack_require__(113);
	
	var _enqForm2 = _interopRequireDefault(_enqForm);
	
	var _bg_enquiry = __webpack_require__(1182);
	
	var _bg_enquiry2 = _interopRequireDefault(_bg_enquiry);
	
	var _header = __webpack_require__(21);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Enquiry = function (_React$Component) {
	   _inherits(Enquiry, _React$Component);
	
	   function Enquiry(props) {
	      _classCallCheck(this, Enquiry);
	
	      // Assign state itself, and a default value for items
	
	      // console.log(props);
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this.state = {
	         fromProp: []
	      };
	
	      return _this;
	   }
	
	   Enquiry.prototype.componentWillMount = function componentWillMount() {
	      this.props.updateMeta("Enquire Now | YarraBend", "Enquire about yarrabend and one of our team will get back to you.");
	      this.props.updatePageType(null);
	   };
	
	   Enquiry.prototype.render = function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          router = _props.router,
	          params = _props.params,
	          location = _props.location,
	          routes = _props.routes;
	
	      this.state.fromProp = location.state && location.state.fromProp != '' ? location.state.fromProp : null;
	      var enquireProperty = location.state && location.state.property != '' ? location.state.property : null;
	      //console.log(this.props);
	      //console.log(location);
	      //console.log(location.state.fromProp);
	      return _react2.default.createElement(
	         "div",
	         null,
	         _react2.default.createElement(_header2.default, { hideEnquire: true, theme: "trans", menu: this.props.data.prismicMainNavigation.data }),
	         _react2.default.createElement(
	            BgWrapper,
	            null,
	            _react2.default.createElement(
	               EnquiryWrapper,
	               null,
	               _react2.default.createElement("div", { className: "close-button", onClick: function onClick() {
	                     return _this2.props.history.goBack();
	                  } }),
	               _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Enquire Now"
	               ),
	               _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Enquire about YarraBend and one of our team will get back to you."
	               ),
	               _react2.default.createElement(_enqForm2.default, { square: true, utm: this.props.utm, property: enquireProperty, fromProp: this.state.fromProp, updateFormDetails: function updateFormDetails(first_name, last_name, phone, email) {
	                     return _this2.props.updateFormDetails(first_name, last_name, phone, email);
	                  } })
	            )
	         )
	      );
	   };
	
	   return Enquiry;
	}(_react2.default.Component);
	
	var BgWrapper = _styledComponents2.default.div(_templateObject, _bg_enquiry2.default, vars.padding.inner, _functions.below.tablet(_templateObject2, vars.padding.tabInner), _functions.below.mobile(_templateObject3, vars.padding.mobInner));
	
	var EnquiryWrapper = _styledComponents2.default.div(_templateObject4, vars.padding.inner * 2, vars.padding.inner, _functions.below.tablet(_templateObject5, vars.padding.tabInner), _functions.below.mobile(_templateObject6, vars.padding.tabInner, vars.padding.mobInner), _functions.below.tablet(_templateObject7, vars.padding.tabInner), _functions.below.mobile(_templateObject7, vars.padding.mobInner), vars.colors.inactiveColor);
	
	exports.default = Enquiry;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 1182:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bg_enquiry.28437381.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-enquire-js-c86c1a6d68c9d91aeb20.js